/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListSyndigoBrandsQueryResponse,
  ListSyndigoBrandsQueryParams,
} from '../../types/ListSyndigoBrands'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listSyndigoBrands } from '../../clients/listSyndigoBrands'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listSyndigoBrandsQueryKey = (
  params?: ListSyndigoBrandsQueryParams
) =>
  [
    { url: '/api/v1/products/catalog/variants/syndigo/brands/' },
    ...(params ? [params] : []),
  ] as const

export type ListSyndigoBrandsQueryKey = ReturnType<
  typeof listSyndigoBrandsQueryKey
>

export function listSyndigoBrandsQueryOptions(
  params?: ListSyndigoBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listSyndigoBrandsQueryKey(params)
  return queryOptions<
    ListSyndigoBrandsQueryResponse,
    ResponseErrorConfig<Error>,
    ListSyndigoBrandsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listSyndigoBrands(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get brands for the company.
 * GET /catalog/variants/syndigo/brands/
 * Deprecated: Use GET /catalog/brands/ instead.
 * Returns:
 * Response with list of brand names sorted alphabetically.
 * Each item has 'label' and 'value' keys for frontend compatibility.
 * @summary List brands (deprecated, use /catalog/brands/)
 * {@link /api/v1/products/catalog/variants/syndigo/brands/}
 * @deprecated
 */
export function useListSyndigoBrands<
  TData = ListSyndigoBrandsQueryResponse,
  TQueryData = ListSyndigoBrandsQueryResponse,
  TQueryKey extends QueryKey = ListSyndigoBrandsQueryKey,
>(
  params?: ListSyndigoBrandsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListSyndigoBrandsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listSyndigoBrandsQueryKey(params)

  const query = useQuery(
    {
      ...listSyndigoBrandsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
